/**
 * Decode the payload (claims) segment of a JWT without verifying its signature.
 * For display/diagnostics only — never trust these claims for authorization
 * decisions (the backend verifies the signature).
 */
export function decodeJwtPayload(token) {
    const payloadB64 = token.split('.')[1];
    if (!payloadB64)
        return null;
    try {
        // Convert base64url → base64, then decode UTF-8 safely.
        const normalized = payloadB64.replace(/-/g, '+').replace(/_/g, '/');
        const json = decodeURIComponent(atob(normalized)
            .split('')
            .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
            .join(''));
        return JSON.parse(json);
    }
    catch {
        return null;
    }
}
